<script>
import apiEndpoints from "@/services/apiEndpoints";
import _debounce from "lodash/debounce";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";
import router from "@/mixins/router";
import CommonTableComponent from "@/components/table.vue";
import { mapGetters } from "vuex";
import user from "@/mixins/user";

export default {
  components: {
    CommonTableComponent
  },
  props: ["data","disableEntry"],
  mixins: [DeviceDetectionMixin, router, user],
  data() {
    return {
      isLoading: false,
      dataSelected: null,
      baseWorkOrderId: null,
      baseWorkOrderName: '',
      visible: false,
      filters: {
        column: "id",
        dir: "DESC",
        page: 1
      }
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("choose-work-order-type");
    },
    getBaseWorkOrder(){
      this.getBaseWorkOrderApi();
    },
    async getBaseWorkOrderApi(){

        const url = apiEndpoints.detail_work_order(this.baseWorkOrderId);
        const {status, data} = await this.$http.getWithLoading(url);
        if (status && data) {
            this.baseWorkOrderName = data.result?.name;
        }else{
          this.baseWorkOrderName = '';
        }
    }
  },
  computed: {
    ...mapGetters("options", ["work_order_type_options"]),
    projectId() {
      return this.$route.params.id;
    },
    queryPage() {
      return this.$route.query;
    }
  }
};
</script>
<template>
  <div class="d-xl-flex">
    <button
      v-b-modal.choose-work-order-type
      class="btn btn-primary w-md waves-effect waves-light"
      v-if="canUserEdit() && !detectMobileDevice()"
      v-bind:disabled="this.disableEntry"
    >
      <i class='fas fa-pencil-alt'></i> 新しい作業指示を登録する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="choose-work-order-type"
      centered
      title-class="font-18"
      hide-footer
      scrollable
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-end w-100 align-items-center" style="height: 0px;">
          <span style="cursor: pointer;" @click="closeModal">×</span>
        </div>
      </template>
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-row>
            <div class="mb-1">新規作成する作業分類を選択してください</div>
            <div class="custom-radio-group" style="padding: 0;">
              <b-form-radio-group
                v-if="work_order_type_options && work_order_type_options.length > 0"
                class="radio-group"
                style="margin-left: 10px;"
                id="work_order_type_options"
                v-model="dataSelected"
                :options="work_order_type_options"
                name="work-order-types-options"
              ></b-form-radio-group>
            </div>
          </b-row>
          <b-row class="mt-2">
            <b-col>次の作業指示IDをもとにする</b-col>
            <b-col cols="2"><b-form-input @change="getBaseWorkOrder()" v-model="baseWorkOrderId"></b-form-input></b-col>
            <b-col cols="8">{{ baseWorkOrderName }}</b-col>
          </b-row>
          <div class="d-flex justify-content-end mt-2">
            <button
              :disabled="!dataSelected"
              @click="
                redirectRoute(
                  'projects.sales.instructions.detail',
                  { id: projectId },
                  { type: dataSelected, baseWorkOrderId: baseWorkOrderId },
                  queryPage,
                  'projects/sales/instruction'
                )
              "
              class="btn btn-primary waves-effect waves-light"
            >
              <i class='fas fa-pencil-alt'></i> 登録
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped lang="scss">
#choose-work-order-type {
  font-size: 16px;
  .custom-radio-group .label-group {
    flex: unset;
  }
}
</style>
